import { jsonApi } from '../http-request';
import { serializeParams } from '../utils';

export const SITE_CONFIG = {
  UPDATED: 'SITE_CONFIG_UPDATED',
};

export const actions = jsonApi.createUpdResourceFacade('site_config');

// This is a temporary action creator until we tie the
// entire life-cycle of site-config into redux
actions.updated = payload => ({
  type: SITE_CONFIG.UPDATED,
  payload,
});

actions.readWithParams = params => {
  const read = actions.read();
  const { payload } = read;

  return {
    ...read,
    payload: {
      ...payload,
      url: `${payload.url}?${serializeParams(params)}`,
    },
  };
};
